import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ResponseModel } from '../domain/authentication.model'
import { CoreEnvironmentService } from './core-environment.service'

// Data types

export enum SubscriptionPlans {
  Free = 20,
  Premium = 100,
  Expert = 9999
}

export type CommonResponseSubscriptionsType = {
  monthes: MonthsCountType
  plan: SubscriptionPlans
}

export type MonthsCountType = 1 | 3 | 12 | 36

export type SubscriptionType = CommonResponseSubscriptionsType & {
  userId: number | null
  couponCode: string | null
}

export type SubscriptionPaymentType = CommonResponseSubscriptionsType & {
  subscriptionCoupon: string
}

// Response types
export type SubscriptionResponseType = {
  price: {
    Item1: number // full price
    Item2: number // price with discount for monthes
  }
  couponDiscount: {
    Item1: number // price with discount for monthes
    Item2: number // price with discount for coupon
  }
}

export type SubscriptionPaymentResponseType = {
  redirectUrl: string
}

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPriceService {
  baseUrl: string

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  getPriceForSubscriptions(data: SubscriptionType): Observable<ResponseModel<SubscriptionResponseType>> {
    return this.http.post<ResponseModel<SubscriptionResponseType>>(
      `${this.baseUrl}/Default/Payment/GetPriceForSubscription`,
      data
    )
  }

  makeSubscriptionPayment(data: SubscriptionPaymentType): Observable<ResponseModel<SubscriptionPaymentResponseType>> {
    return this.http.post<ResponseModel<SubscriptionPaymentResponseType>>(
      `${this.baseUrl}/default/payment/MakeSubscriptionPayment`,
      data
    )
  }
}
